<template>
  <v-container fill-height fluid>
    
    <v-row v-if="animalName != null">
      <v-col align="center" justify="center">
        <h1>分析結果</h1>
      </v-col>
    </v-row>
    <v-row v-if="animalName != null">
      <v-card class="mx-auto my-6" max-width="374" elevation="2" outlined>
        <v-col align="center" justify="center">
          <v-img :src="'/img/' + animal[animalName].image_name"></v-img>
        </v-col>

        <v-card-title
          >{{ animal[animalName].name }} |
          {{ animal[animalName].type }}</v-card-title
        >

        <v-card-text>
          <div class="my-4 subtitle-1"></div>
          <div>
            {{ animal[animalName].desc }}
          </div>
        </v-card-text>
        <v-row>
           <ve-radar 
            :data="chartData" 
            :settings="chartSettings"
            :legend-visible="false"
            :extend="radarChartDataExtend"
            style="height:50%;width:100%;margin-top:20px"
            ></ve-radar>
        </v-row>

        <!-- <v-divider class="mx-4"></v-divider> -->
        <h3 class="padding">填寫小朋友的資訊取得個人化推薦結果</h3>
        <v-row class="padding">
          <v-col cols="12" sm="12">
            <v-text-field
              v-model="name"
              solo
              label="小孩的名字"
              clearable
            ></v-text-field>
            <v-select
              v-model="gender"
              :items="genderSelect"
              item-text="name"
              item-value="value"
              label="小孩的性別"
              solo
            ></v-select>


            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="birthday"
                  label="小孩的出生日期"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="birthday"
                locale="zh-TW"
                :max="new Date().toISOString().substr(0, 10)"
                min="1950-01-01"
                @change="save"
              ></v-date-picker>
            </v-menu>

            <!-- <v-row justify="center">
              <v-date-picker v-model="picker"></v-date-picker>
            </v-row> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center" justify="center">
            <v-btn rounded color="success" dark x-large @click="goBooksPage()">
              查看推薦書籍
            </v-btn>
          </v-col>
        </v-row>

        

        <br />
      </v-card>
    </v-row>

    <v-row v-else>
      <v-col align="center" justify="center">
        <v-progress-circular
        indeterminate
        color="primary"
        ></v-progress-circular>
      </v-col>
    </v-row>

    <!-- <book-result v-if="showRecommendBooks">

      </book-result> -->

    <br /><br /><br />
    <br /><br /><br />
    <br /><br /><br />
    <br /><br /><br />
    <br /><br /><br />
    <br /><br /><br />
    <!-- <v-row>
      <v-col align="center" justify="center" class="fixed-button">
        <v-btn rounded color="success" dark x-large @click="goBooksPage()">
          查看推薦書籍
        </v-btn>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
// @ is an alias to /src
import animalJSON from "@/data/animal.json";
// import BookResult from "@/views/BookResult.vue";
import VeRadar from 'v-charts/lib/radar.common'
let api_url = process.env.VUE_APP_API_URL;


export default {
  name: "RecommendSurvey",
  components: {
    // BookResult,
    VeRadar
  },
  data() {
    return {
      animal: animalJSON,
      animalName: null,
      timeoutCounter: null,
      type: null,
      menu: false,
      // name: "bentest",
      // birthday: "2016-01-01",
      // gender: 'M',
      name: null,
      birthday: null,
      gender: null,
      genderSelect: [
        { name: "男生", value: "M" },
        { name: "女生", value: "F" },
      ],
      showRecommendBooks: false,
      chartSettings: {
        tooltipVisible:"false",
        max: 100,
        labelMap: {
            'name': '檢測結果',
            'curiosity': '好奇',
            'introvert': '內向',
            'nervousness': '緊張',
            'perfection': '完美',
            'peace': '平和',
        },
        
        
        areaStyle: {
            type: 'default',
            opacity: 0.8, // 圖表中各個圖區域的透明度
            color: ['rgba(10,146,72,.1)','rgba(93,183,134,.8)', 'rgba(148,207,175,.5)', 'rgba(116,182,201,.5)', 'rgba(155,199,230,.5)'] // 圖表中各個圖區域的顏色
        },
      },
      radarChartDataExtend: {
               radar:{
                 indicator: [
                  { name: '好奇', max: 10},
                  { name: '內向', max: 10}, 
                  { name: '緊張', max: 10},
                  { name: '完美', max: 10},
                  { name: '平和', max: 10} 
            ]}
      },
      legend:  { enabled: false },
      chartData: {
          columns: ['name', 'curiosity', 'introvert', 'nervousness', 'perfection', 'peace'],
          rows: [
            // { 'name': "檢測結果", 'curiosity': 10, 'introvert': 10, 'nervousness': 10, 'perfection': 10, 'peace': 10},
            { 'name': "檢測結果", 'curiosity': 3, 'introvert': 3, 'nervousness': 4, 'perfection': 10, 'peace': 5 },
          ],
        }


    };
  },
  computed: {
    isLiffReady() {
      return this.$store.state.accessToken
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    isLiffReady(newValue, oldValue) {
      console.log('isLiffReady changed to ', newValue);
      this.getOrCreateUser();

    }
  },
  mounted() {},
  created() {
    // this.$store.commit("setUserId", "U5687c7bd7549dc662d9d3d63f11ac5cd");
    // this.$store.commit("setAccessToken", "eyJhbGciOiJIUzI1NiJ9.KmPoPTeHZY12BV798rUPGbuhgIlYFqJhzQZojBdfYDtY5GBsUJsHp1Xkot99booeOJMhyxIyNfMj375P-6OlSZCGjol-x3utB_QxrhuyxQjPyAbCgAFSAR_ih7IGmclXWb1fzjSKkdkm4fiUMxZdEpOIjrPB58J5PAun1vYz5qw.C3FqvGCjd3iCDiWdWlHi4Tzckql32GcHyhDssVzMw8o")

    this.getOrCreateUser();

    this.timeoutCounter = window.setTimeout( () => {
        alert('前往分析結果')
        this.getOrCreateUser();
      }, 8000);


    // let animalList = Object.keys(this.animal);
    // this.animalName = animalList[Math.floor(Math.random() * animalList.length)];

  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    getOrCreateUser() {
      
      
      var data = JSON.stringify({
        "access_token": this.$store.state.accessToken
      });
      console.log("in get or create: ", this.$store.state.accessToken);
      var xhr = new XMLHttpRequest();


      xhr.addEventListener("readystatechange",  () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {

            // TODO: remove setLoginUrl, not be used
            this.$store.commit("setLoginUrl", result.url);

            this.getMemberType();
            if (this.timeoutCounter) {
              window.clearTimeout(this.timeoutCounter);
            }
          } else {
            // alert(result.error.message);
          }
        }
      });

      xhr.open("POST", api_url + "/api/family/");
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    },
    getMemberType() {
      var data = JSON.stringify(false);
      var xhr = new XMLHttpRequest();

      xhr.addEventListener("readystatechange", () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {
            this.type = result["type"];
            console.log(this.type);
            this.animalName = _typeToAnimal(this.type);
            let radarData = result['scores'];
            radarData['name'] = "檢測結果";
            this.$set(this.chartData.rows, 0, radarData);
          } else {
            // alert(result.error.message);
          }
        }
      });

      xhr.open("GET", api_url + "/api/books/" + this.$store.state.userId + "/type/");
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    },

    goBooksPage() {
      console.log(this.birthday, this.name, this.gender);
      if (_checkHasValue([this.name, this.birthday, this.gender])) {
        console.log('ok');
        if (!this.$store.state.familyMemberId) {
          this.bindFamilyMember();
          return
        }
        // this.showRecommendBooks = true;
        this.$router.push("books");
      } else {
        alert("請先填寫資料");
      }
      console.log("show");
      // this.showRecommendBooks = true;
    },

    bindFamilyMember() {
      var data = JSON.stringify({
        "access_token": this.$store.state.accessToken,
        "name": this.name,
        "birthday": this.birthday,
        "gender": this.gender
      });

      var xhr = new XMLHttpRequest();

      xhr.addEventListener("readystatechange",  () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {
            this.$store.commit("setFamilyMemberId", result.member_id);
            this.$router.push("books");
            // this.showRecommendBooks = true;
          } else {
            alert(result.error.message);
          }
        }
      });

      xhr.open("POST", api_url + "/api/family/" + this.$store.state.userId + "/members/");
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    }

    
  },
};

function _typeToAnimal(type) {
  let animal = null;
  switch (type) {
    case "curiosity":
      animal = "dolphin";
      break;
    case "introvert":
      animal = "panda";
      break;
    case "nervousness":
      animal = "deer";
      break;
    case "perfection":
      animal = "peacock";
      break;
    case "peace":
      animal = "elephant";
      break;
  }
  return animal;
}
function _checkHasValue(valueList) {
      
    let status = true
    valueList.forEach(element => {
      if (!element) {
        status = false
      }
    });
    return status
  }
</script>

<style>
.padding {
  padding: 10px;
}
</style>